import themeStyles from "../utils/themeStyles";
import { VsiLgText } from "../styled/App.styled";
import { determineEnvBarColor } from "../utils/chartUtils";
import React from "react";
import { useVsiAppContext } from "../stores/VsiApp";
import { withErrorBoundary } from "../boundaries/withErrorBoundary";
import GeneralErrorBoundary from "../boundaries/GeneralErrorBoundary";

function EnvironmentProgressBar ({ value }) {
  const {theme} = useVsiAppContext();
  const val = value > 100 ? 100 : value;
  return (
    <div className={"w-100"} style={{
      borderRadius: '20px',
      backgroundColor: themeStyles[theme].altBgColor,
    }}>
      <VsiLgText className="ps-1" style={{ textAlign: 'right', position: 'absolute'}}>
        {`${Math.round(value)}%`}
      </VsiLgText>
      <div className={"d-flex flex-row justify-content-end"} style={{
        width: `${val}%`,
        backgroundColor: determineEnvBarColor(value),
        borderRadius: '10px',
      }}>
        <VsiLgText style={{ textAlign: 'right',  color: "transparent"}}>
          {`VSI`}
        </VsiLgText>
      </div>
    </div>
  )
}

export default withErrorBoundary(EnvironmentProgressBar, GeneralErrorBoundary);
